import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import React, { useEffect, useState } from "react";
import axios from "axios";

const headers = [
  {
    key: "product_name",
    name: "Product Name",
  },
  {
    key: "barcode",
    name: "Barcode",
  },
  {
    key: "product_category_name",
    parent: "productCategory",
    name: "Category",
  },
  {
    key: "status",
    name: "Status",
  },
];

export default function ProductList() {
  const [units, setUnits] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    axios
      .get(API_URL + "/unit", { withCredentials: true })
      .then((res) => setUnits(res.data.data || []))
      .catch((err) => console.error("Failed to load units", err));
  }, []);

  const detailPopupHeaders = [
    {
      key: "product_code",
      name: "Product Code",
    },
    {
      key: "product_name",
      name: "Product Name",
    },
    {
      key: "prefix_code",
      name: "Prefix Code",
    },
    {
      key: "barcode",
      name: "Barcode",
    },
    {
      key: "product_category_name",
      parent: "productCategory",
      name: "Product Category",
    },
    {
      key: "retail_price",
      parent: "productPrice",
      name: "Retail Price",
    },
    {
      key: "wholesale_price",
      parent: "productPrice",
      name: "Wholesale Price",
    },
    {
      key: "sku_unit_id",
      parent: "productPrice",
      name: "SKU",
      render: (value) => {
        const found = units.find((u) => u.unit_id === value);
        return found ? found.unit_name : value;
      },
    },
    {
      key: "price_date",
      parent: "productPrice",
      name: "Price Date",
    },
    {
      key: "remark",
      name: "Remark",
    },
  ];

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/product",
    defaultQuery: "status=ACTIVE",
  });

  const handleSearch = (value) => {
    const trimmed = value.trim();
    if(trimmed.length > 0){
      setSearchValue(trimmed);
      setQuery({ search: trimmed });
    }else{
      setQuery({});
    }
  };

  const nothingFoundAfterSearch =
    searchValue && Array.isArray(data?.results) && data.results.length === 0;

  return (
    <TableLayout
      title="Product List"
      data={data}
      headers={headers}
      detailPopupHeaders={detailPopupHeaders}
      detailPopupTitle="Product Information"
      setCurrentPage={setCurrentPage}
      idKey="product_id"
      endPoint="/product"
      hasSearch
      hasCreate
      module="Product"
      subModule="Product List"
      hasPrintBarcode
      createPath={`/product/list/create`}
      hasActions
      currentPath={currentPath}
      onSearch={handleSearch}
      reload={reload}
      setQuery={setQuery}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
    />
  );
}
